import { LegalPage } from "../components/LegalPage";
import { SEO } from "../lib/seo";

export const AcceptableUsePage = () => (
  <>
    <SEO
      title="Acceptable Use Policy"
      description="The rules of the road for using Humaniti — what's allowed, what isn't, and how violations are handled."
      path="/acceptable-use"
    />
    <LegalPage
      title="Acceptable Use Policy"
      effectiveDate="2026-04-23"
      intro={
        <p>
          The Humaniti network depends on good-faith participation by both requesters and
          annotators. This policy describes what is and isn't allowed.
        </p>
      }
      sections={[
        {
          id: "annotator",
          title: "1. For annotators",
          body: (
            <ul>
              <li>Submit your own work. Don't outsource to others or to AI.</li>
              <li>Don't use multiple accounts to claim more tasks than your tier allows.</li>
              <li>Don't share account credentials.</li>
              <li>Engage with disputes in good faith.</li>
            </ul>
          ),
        },
        {
          id: "requester",
          title: "2. For requesters",
          body: (
            <ul>
              <li>
                Don't publish tasks involving content that is illegal in your jurisdiction or ours.
              </li>
              <li>Don't reject in bad faith. Rejection without reason hurts your trust score.</li>
              <li>Pay rates that reflect the work involved. Underpayment will be reviewed.</li>
            </ul>
          ),
        },
        {
          id: "everyone",
          title: "3. For everyone",
          body: (
            <ul>
              <li>Don't attempt to game consensus or quality systems.</li>
              <li>Don't attempt to identify other users.</li>
              <li>Don't use the platform for any purpose that violates applicable law.</li>
            </ul>
          ),
        },
        {
          id: "enforcement",
          title: "4. Enforcement",
          body: (
            <p>
              Violations may result in warnings, account suspension, payout forfeiture, or permanent
              ban depending on severity. Appeals via support@humaniti.io.
            </p>
          ),
        },
      ]}
    />
  </>
);
